import { BlocksIconSocialX } from 'blocks-nextjs/blocks-web-components/components/icon/icons/social-x';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSocialX = createComponent({
  react: React,
  tagName: 'cat-icon-social-x',
  elementClass: BlocksIconSocialX,
  events: {}
});
